const tokens = {
  "animations.fadeIn": {
    "value": "fadeIn 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--bmt-animations-fade-in)"
  },
  "animations.fadeOut": {
    "value": "fadeOut 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--bmt-animations-fade-out)"
  },
  "animations.scaleIn": {
    "value": "scaleIn 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--bmt-animations-scale-in)"
  },
  "animations.scaleOut": {
    "value": "scaleOut 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--bmt-animations-scale-out)"
  },
  "animations.dialogScaleIn": {
    "value": "fadeIn 0.15s, dialogScaleIn 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--bmt-animations-dialog-scale-in)"
  },
  "animations.dialogScaleOut": {
    "value": "fadeOut 0.15s, dialogScaleOut 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--bmt-animations-dialog-scale-out)"
  },
  "animations.slideLeftIn": {
    "value": "fadeIn 0.3s, slideLeftIn 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
    "variable": "var(--bmt-animations-slide-left-in)"
  },
  "animations.slideRightIn": {
    "value": "fadeIn 0.3s, slideRightIn 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
    "variable": "var(--bmt-animations-slide-right-in)"
  },
  "animations.slideLeftOut": {
    "value": "fadeOut 0.3s, slideLeftOut 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
    "variable": "var(--bmt-animations-slide-left-out)"
  },
  "animations.slideRightOut": {
    "value": "fadeOut 0.3s, slideRightOut 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
    "variable": "var(--bmt-animations-slide-right-out)"
  },
  "animations.accordionDown": {
    "value": "accordionDown 0.2s ease-out",
    "variable": "var(--bmt-animations-accordion-down)"
  },
  "animations.accordionUp": {
    "value": "accordionUp 0.2s ease-out",
    "variable": "var(--bmt-animations-accordion-up)"
  },
  "animations.shimmerPulse": {
    "value": "shimmerPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--bmt-animations-shimmer-pulse)"
  },
  "borderWidths.none": {
    "value": "0px",
    "variable": "var(--bmt-border-widths-none)"
  },
  "borderWidths.thin": {
    "value": "1px",
    "variable": "var(--bmt-border-widths-thin)"
  },
  "borderWidths.thick": {
    "value": "2px",
    "variable": "var(--bmt-border-widths-thick)"
  },
  "colors.primitives.black": {
    "value": "#000000",
    "variable": "var(--bmt-colors-primitives-black)"
  },
  "colors.primitives.blue.10": {
    "value": "#e3f8ff",
    "variable": "var(--bmt-colors-primitives-blue-10)"
  },
  "colors.primitives.blue.20": {
    "value": "#bbdcfa",
    "variable": "var(--bmt-colors-primitives-blue-20)"
  },
  "colors.primitives.blue.30": {
    "value": "#87b8f5",
    "variable": "var(--bmt-colors-primitives-blue-30)"
  },
  "colors.primitives.blue.40": {
    "value": "#5696ee",
    "variable": "var(--bmt-colors-primitives-blue-40)"
  },
  "colors.primitives.blue.50": {
    "value": "#2c78ea",
    "variable": "var(--bmt-colors-primitives-blue-50)"
  },
  "colors.primitives.blue.60": {
    "value": "#1d6ae5",
    "variable": "var(--bmt-colors-primitives-blue-60)"
  },
  "colors.primitives.blue.70": {
    "value": "#1856ba",
    "variable": "var(--bmt-colors-primitives-blue-70)"
  },
  "colors.primitives.blue.80": {
    "value": "#0042ab",
    "variable": "var(--bmt-colors-primitives-blue-80)"
  },
  "colors.primitives.blue.90": {
    "value": "#002a91",
    "variable": "var(--bmt-colors-primitives-blue-90)"
  },
  "colors.primitives.blue.100": {
    "value": "#071b39",
    "variable": "var(--bmt-colors-primitives-blue-100)"
  },
  "colors.primitives.blue.60alpha30": {
    "value": "#1d6ae54d",
    "variable": "var(--bmt-colors-primitives-blue-60alpha30)"
  },
  "colors.primitives.blue.60alpha40": {
    "value": "#1d6ae566",
    "variable": "var(--bmt-colors-primitives-blue-60alpha40)"
  },
  "colors.primitives.gold.10": {
    "value": "#fcfcd0",
    "variable": "var(--bmt-colors-primitives-gold-10)"
  },
  "colors.primitives.gold.20": {
    "value": "#fdf3b4",
    "variable": "var(--bmt-colors-primitives-gold-20)"
  },
  "colors.primitives.gold.30": {
    "value": "#fdeb99",
    "variable": "var(--bmt-colors-primitives-gold-30)"
  },
  "colors.primitives.gold.40": {
    "value": "#fee27d",
    "variable": "var(--bmt-colors-primitives-gold-40)"
  },
  "colors.primitives.gold.50": {
    "value": "#ffd553",
    "variable": "var(--bmt-colors-primitives-gold-50)"
  },
  "colors.primitives.gold.60": {
    "value": "#ffc729",
    "variable": "var(--bmt-colors-primitives-gold-60)"
  },
  "colors.primitives.gold.70": {
    "value": "#b18b21",
    "variable": "var(--bmt-colors-primitives-gold-70)"
  },
  "colors.primitives.gold.80": {
    "value": "#725812",
    "variable": "var(--bmt-colors-primitives-gold-80)"
  },
  "colors.primitives.gold.90": {
    "value": "#5a4a1c",
    "variable": "var(--bmt-colors-primitives-gold-90)"
  },
  "colors.primitives.gold.100": {
    "value": "#33280c",
    "variable": "var(--bmt-colors-primitives-gold-100)"
  },
  "colors.primitives.grey.10": {
    "value": "#f5f5f5",
    "variable": "var(--bmt-colors-primitives-grey-10)"
  },
  "colors.primitives.grey.20": {
    "value": "#e6e6e6",
    "variable": "var(--bmt-colors-primitives-grey-20)"
  },
  "colors.primitives.grey.30": {
    "value": "#c7c7c7",
    "variable": "var(--bmt-colors-primitives-grey-30)"
  },
  "colors.primitives.grey.40": {
    "value": "#a8a8a8",
    "variable": "var(--bmt-colors-primitives-grey-40)"
  },
  "colors.primitives.grey.50": {
    "value": "#8f8f8f",
    "variable": "var(--bmt-colors-primitives-grey-50)"
  },
  "colors.primitives.grey.60": {
    "value": "#757575",
    "variable": "var(--bmt-colors-primitives-grey-60)"
  },
  "colors.primitives.grey.70": {
    "value": "#5c5c5c",
    "variable": "var(--bmt-colors-primitives-grey-70)"
  },
  "colors.primitives.grey.80": {
    "value": "#424242",
    "variable": "var(--bmt-colors-primitives-grey-80)"
  },
  "colors.primitives.grey.90": {
    "value": "#212121",
    "variable": "var(--bmt-colors-primitives-grey-90)"
  },
  "colors.primitives.grey.100": {
    "value": "#121212",
    "variable": "var(--bmt-colors-primitives-grey-100)"
  },
  "colors.primitives.grey.90alpha05": {
    "value": "#2121210d",
    "variable": "var(--bmt-colors-primitives-grey-90alpha05)"
  },
  "colors.primitives.grey.90alpha10": {
    "value": "#2121211a",
    "variable": "var(--bmt-colors-primitives-grey-90alpha10)"
  },
  "colors.primitives.grey.90alpha15": {
    "value": "#21212126",
    "variable": "var(--bmt-colors-primitives-grey-90alpha15)"
  },
  "colors.primitives.grey.90alpha40": {
    "value": "#21212166",
    "variable": "var(--bmt-colors-primitives-grey-90alpha40)"
  },
  "colors.primitives.grey.90alpha80": {
    "value": "#212121cc",
    "variable": "var(--bmt-colors-primitives-grey-90alpha80)"
  },
  "colors.primitives.navy.10": {
    "value": "#d2dbfb",
    "variable": "var(--bmt-colors-primitives-navy-10)"
  },
  "colors.primitives.navy.20": {
    "value": "#b5c7f7",
    "variable": "var(--bmt-colors-primitives-navy-20)"
  },
  "colors.primitives.navy.30": {
    "value": "#a5b6f1",
    "variable": "var(--bmt-colors-primitives-navy-30)"
  },
  "colors.primitives.navy.40": {
    "value": "#7f92d6",
    "variable": "var(--bmt-colors-primitives-navy-40)"
  },
  "colors.primitives.navy.50": {
    "value": "#687dc7",
    "variable": "var(--bmt-colors-primitives-navy-50)"
  },
  "colors.primitives.navy.60": {
    "value": "#666d96",
    "variable": "var(--bmt-colors-primitives-navy-60)"
  },
  "colors.primitives.navy.70": {
    "value": "#4a59b7",
    "variable": "var(--bmt-colors-primitives-navy-70)"
  },
  "colors.primitives.navy.80": {
    "value": "#343f86",
    "variable": "var(--bmt-colors-primitives-navy-80)"
  },
  "colors.primitives.navy.90": {
    "value": "#26306a",
    "variable": "var(--bmt-colors-primitives-navy-90)"
  },
  "colors.primitives.navy.100": {
    "value": "#000b50",
    "variable": "var(--bmt-colors-primitives-navy-100)"
  },
  "colors.primitives.navy.40alpha30": {
    "value": "#7f92d64d",
    "variable": "var(--bmt-colors-primitives-navy-40alpha30)"
  },
  "colors.primitives.orange.10": {
    "value": "#fff2f2",
    "variable": "var(--bmt-colors-primitives-orange-10)"
  },
  "colors.primitives.orange.20": {
    "value": "#fed4be",
    "variable": "var(--bmt-colors-primitives-orange-20)"
  },
  "colors.primitives.orange.30": {
    "value": "#fdb78c",
    "variable": "var(--bmt-colors-primitives-orange-30)"
  },
  "colors.primitives.orange.40": {
    "value": "#fb9a5b",
    "variable": "var(--bmt-colors-primitives-orange-40)"
  },
  "colors.primitives.orange.50": {
    "value": "#fa7d29",
    "variable": "var(--bmt-colors-primitives-orange-50)"
  },
  "colors.primitives.orange.60": {
    "value": "#f56b0f",
    "variable": "var(--bmt-colors-primitives-orange-60)"
  },
  "colors.primitives.orange.70": {
    "value": "#d85511",
    "variable": "var(--bmt-colors-primitives-orange-70)"
  },
  "colors.primitives.orange.80": {
    "value": "#c74106",
    "variable": "var(--bmt-colors-primitives-orange-80)"
  },
  "colors.primitives.orange.90": {
    "value": "#7d2903",
    "variable": "var(--bmt-colors-primitives-orange-90)"
  },
  "colors.primitives.orange.100": {
    "value": "#341101",
    "variable": "var(--bmt-colors-primitives-orange-100)"
  },
  "colors.primitives.orange.60alpha30": {
    "value": "#f56b0f4d",
    "variable": "var(--bmt-colors-primitives-orange-60alpha30)"
  },
  "colors.primitives.purple.10": {
    "value": "#e2d8fb",
    "variable": "var(--bmt-colors-primitives-purple-10)"
  },
  "colors.primitives.purple.20": {
    "value": "#d4c5f9",
    "variable": "var(--bmt-colors-primitives-purple-20)"
  },
  "colors.primitives.purple.30": {
    "value": "#c3acfd",
    "variable": "var(--bmt-colors-primitives-purple-30)"
  },
  "colors.primitives.purple.40": {
    "value": "#b79ef5",
    "variable": "var(--bmt-colors-primitives-purple-40)"
  },
  "colors.primitives.purple.50": {
    "value": "#a281f1",
    "variable": "var(--bmt-colors-primitives-purple-50)"
  },
  "colors.primitives.purple.60": {
    "value": "#946def",
    "variable": "var(--bmt-colors-primitives-purple-60)"
  },
  "colors.primitives.purple.70": {
    "value": "#8657f6",
    "variable": "var(--bmt-colors-primitives-purple-70)"
  },
  "colors.primitives.purple.80": {
    "value": "#703dea",
    "variable": "var(--bmt-colors-primitives-purple-80)"
  },
  "colors.primitives.purple.90": {
    "value": "#471ab5",
    "variable": "var(--bmt-colors-primitives-purple-90)"
  },
  "colors.primitives.purple.100": {
    "value": "#361683",
    "variable": "var(--bmt-colors-primitives-purple-100)"
  },
  "colors.primitives.purple.50alpha30": {
    "value": "#a281f14d",
    "variable": "var(--bmt-colors-primitives-purple-50alpha30)"
  },
  "colors.primitives.teal.10": {
    "value": "#dafcf5",
    "variable": "var(--bmt-colors-primitives-teal-10)"
  },
  "colors.primitives.teal.20": {
    "value": "#bdedeb",
    "variable": "var(--bmt-colors-primitives-teal-20)"
  },
  "colors.primitives.teal.30": {
    "value": "#a0dfe1",
    "variable": "var(--bmt-colors-primitives-teal-30)"
  },
  "colors.primitives.teal.40": {
    "value": "#83d1d6",
    "variable": "var(--bmt-colors-primitives-teal-40)"
  },
  "colors.primitives.teal.50": {
    "value": "#66c2cc",
    "variable": "var(--bmt-colors-primitives-teal-50)"
  },
  "colors.primitives.teal.60": {
    "value": "#3aa2ae",
    "variable": "var(--bmt-colors-primitives-teal-60)"
  },
  "colors.primitives.teal.70": {
    "value": "#47919b",
    "variable": "var(--bmt-colors-primitives-teal-70)"
  },
  "colors.primitives.teal.80": {
    "value": "#226d78",
    "variable": "var(--bmt-colors-primitives-teal-80)"
  },
  "colors.primitives.teal.90": {
    "value": "#21494e",
    "variable": "var(--bmt-colors-primitives-teal-90)"
  },
  "colors.primitives.teal.100": {
    "value": "#132a2e",
    "variable": "var(--bmt-colors-primitives-teal-100)"
  },
  "colors.primitives.teal.60alpha20": {
    "value": "#3aa2ae33",
    "variable": "var(--bmt-colors-primitives-teal-60alpha20)"
  },
  "colors.primitives.transparent": {
    "value": "#ffffff00",
    "variable": "var(--bmt-colors-primitives-transparent)"
  },
  "colors.primitives.red.10": {
    "value": "#fff2f2",
    "variable": "var(--bmt-colors-primitives-red-10)"
  },
  "colors.primitives.red.20": {
    "value": "#ffcfcd",
    "variable": "var(--bmt-colors-primitives-red-20)"
  },
  "colors.primitives.red.30": {
    "value": "#ffafaa",
    "variable": "var(--bmt-colors-primitives-red-30)"
  },
  "colors.primitives.red.40": {
    "value": "#ff948d",
    "variable": "var(--bmt-colors-primitives-red-40)"
  },
  "colors.primitives.red.50": {
    "value": "#ff7970",
    "variable": "var(--bmt-colors-primitives-red-50)"
  },
  "colors.primitives.red.60": {
    "value": "#f44e44",
    "variable": "var(--bmt-colors-primitives-red-60)"
  },
  "colors.primitives.red.70": {
    "value": "#d0372d",
    "variable": "var(--bmt-colors-primitives-red-70)"
  },
  "colors.primitives.red.80": {
    "value": "#b0261d",
    "variable": "var(--bmt-colors-primitives-red-80)"
  },
  "colors.primitives.red.90": {
    "value": "#87140d",
    "variable": "var(--bmt-colors-primitives-red-90)"
  },
  "colors.primitives.red.100": {
    "value": "#4d0a06",
    "variable": "var(--bmt-colors-primitives-red-100)"
  },
  "colors.primitives.red.70alpha40": {
    "value": "#d0372d66",
    "variable": "var(--bmt-colors-primitives-red-70alpha40)"
  },
  "colors.primitives.white.100": {
    "value": "#ffffff",
    "variable": "var(--bmt-colors-primitives-white-100)"
  },
  "colors.primitives.white.100alpha05": {
    "value": "#ffffff0d",
    "variable": "var(--bmt-colors-primitives-white-100alpha05)"
  },
  "colors.primitives.white.100alpha10": {
    "value": "#ffffff1a",
    "variable": "var(--bmt-colors-primitives-white-100alpha10)"
  },
  "colors.primitives.white.100alpha15": {
    "value": "#ffffff26",
    "variable": "var(--bmt-colors-primitives-white-100alpha15)"
  },
  "colors.primitives.white.100alpha30": {
    "value": "#ffffff4d",
    "variable": "var(--bmt-colors-primitives-white-100alpha30)"
  },
  "colors.primitives.white.100alpha40": {
    "value": "#ffffff66",
    "variable": "var(--bmt-colors-primitives-white-100alpha40)"
  },
  "colors.primitives.white.100alpha60": {
    "value": "#ffffff99",
    "variable": "var(--bmt-colors-primitives-white-100alpha60)"
  },
  "fonts.gtAmerica": {
    "value": "GT America",
    "variable": "var(--bmt-fonts-gt-america)"
  },
  "fonts.gtAmericaExtended": {
    "value": "GT America Extended",
    "variable": "var(--bmt-fonts-gt-america-extended)"
  },
  "fontSizes.fontSize.25": {
    "value": "12px",
    "variable": "var(--bmt-font-sizes-font-size-25)"
  },
  "fontSizes.fontSize.30": {
    "value": "13px",
    "variable": "var(--bmt-font-sizes-font-size-30)"
  },
  "fontSizes.fontSize.50": {
    "value": "14px",
    "variable": "var(--bmt-font-sizes-font-size-50)"
  },
  "fontSizes.fontSize.100": {
    "value": "16px",
    "variable": "var(--bmt-font-sizes-font-size-100)"
  },
  "fontSizes.fontSize.200": {
    "value": "18px",
    "variable": "var(--bmt-font-sizes-font-size-200)"
  },
  "fontSizes.fontSize.300": {
    "value": "24px",
    "variable": "var(--bmt-font-sizes-font-size-300)"
  },
  "fontSizes.fontSize.400": {
    "value": "32px",
    "variable": "var(--bmt-font-sizes-font-size-400)"
  },
  "fontWeights.regular": {
    "value": "500",
    "variable": "var(--bmt-font-weights-regular)"
  },
  "fontWeights.medium": {
    "value": "600",
    "variable": "var(--bmt-font-weights-medium)"
  },
  "letterSpacings.normal": {
    "value": "0px",
    "variable": "var(--bmt-letter-spacings-normal)"
  },
  "letterSpacings.loose": {
    "value": "0.65px",
    "variable": "var(--bmt-letter-spacings-loose)"
  },
  "radii.none": {
    "value": "0px",
    "variable": "var(--bmt-radii-none)"
  },
  "radii.medium": {
    "value": "4px",
    "variable": "var(--bmt-radii-medium)"
  },
  "radii.large": {
    "value": "8px",
    "variable": "var(--bmt-radii-large)"
  },
  "radii.round": {
    "value": "9999px",
    "variable": "var(--bmt-radii-round)"
  },
  "shadows.default": {
    "value": "0 0 15px rgba(0, 0, 0, 0.25)",
    "variable": "var(--bmt-shadows-default)"
  },
  "shadows.xs": {
    "value": "0 1px rgba(0, 0, 0, 0.06)",
    "variable": "var(--bmt-shadows-xs)"
  },
  "shadows.sm": {
    "value": "1px 2px 4px rgba(0, 0, 0, 0.09)",
    "variable": "var(--bmt-shadows-sm)"
  },
  "sizes.size.0": {
    "value": "0px",
    "variable": "var(--bmt-sizes-size-0)"
  },
  "sizes.size.1": {
    "value": "1px",
    "variable": "var(--bmt-sizes-size-1)"
  },
  "sizes.size.50": {
    "value": "4px",
    "variable": "var(--bmt-sizes-size-50)"
  },
  "sizes.size.100": {
    "value": "8px",
    "variable": "var(--bmt-sizes-size-100)"
  },
  "sizes.size.200": {
    "value": "16px",
    "variable": "var(--bmt-sizes-size-200)"
  },
  "sizes.size.250": {
    "value": "20px",
    "variable": "var(--bmt-sizes-size-250)"
  },
  "sizes.size.300": {
    "value": "24px",
    "variable": "var(--bmt-sizes-size-300)"
  },
  "sizes.size.400": {
    "value": "32px",
    "variable": "var(--bmt-sizes-size-400)"
  },
  "sizes.size.450": {
    "value": "36px",
    "variable": "var(--bmt-sizes-size-450)"
  },
  "sizes.size.500": {
    "value": "40px",
    "variable": "var(--bmt-sizes-size-500)"
  },
  "sizes.size.600": {
    "value": "48px",
    "variable": "var(--bmt-sizes-size-600)"
  },
  "sizes.size.800": {
    "value": "64px",
    "variable": "var(--bmt-sizes-size-800)"
  },
  "sizes.size.900": {
    "value": "72px",
    "variable": "var(--bmt-sizes-size-900)"
  },
  "sizes.icon.xxsmall": {
    "value": "16px",
    "variable": "var(--bmt-sizes-icon-xxsmall)"
  },
  "sizes.icon.xsmall": {
    "value": "20px",
    "variable": "var(--bmt-sizes-icon-xsmall)"
  },
  "sizes.icon.small": {
    "value": "24px",
    "variable": "var(--bmt-sizes-icon-small)"
  },
  "sizes.icon.medium": {
    "value": "48px",
    "variable": "var(--bmt-sizes-icon-medium)"
  },
  "sizes.icon.large": {
    "value": "72px",
    "variable": "var(--bmt-sizes-icon-large)"
  },
  "sizes.container.small": {
    "value": "320px",
    "variable": "var(--bmt-sizes-container-small)"
  },
  "sizes.container.medium": {
    "value": "400px",
    "variable": "var(--bmt-sizes-container-medium)"
  },
  "sizes.container.large": {
    "value": "640px",
    "variable": "var(--bmt-sizes-container-large)"
  },
  "sizes.container.xlarge": {
    "value": "800px",
    "variable": "var(--bmt-sizes-container-xlarge)"
  },
  "sizes.container.max": {
    "value": "1200px",
    "variable": "var(--bmt-sizes-container-max)"
  },
  "sizes.layout.slotMinWidth": {
    "value": "380px",
    "variable": "var(--bmt-sizes-layout-slot-min-width)"
  },
  "sizes.breakpoint-sm": {
    "value": "500px",
    "variable": "var(--bmt-sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "700px",
    "variable": "var(--bmt-sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "964px",
    "variable": "var(--bmt-sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1224px",
    "variable": "var(--bmt-sizes-breakpoint-xl)"
  },
  "spacing.space.0": {
    "value": "0px",
    "variable": "var(--bmt-spacing-space-0)"
  },
  "spacing.space.25": {
    "value": "2px",
    "variable": "var(--bmt-spacing-space-25)"
  },
  "spacing.space.50": {
    "value": "4px",
    "variable": "var(--bmt-spacing-space-50)"
  },
  "spacing.space.100": {
    "value": "8px",
    "variable": "var(--bmt-spacing-space-100)"
  },
  "spacing.space.150": {
    "value": "12px",
    "variable": "var(--bmt-spacing-space-150)"
  },
  "spacing.space.200": {
    "value": "16px",
    "variable": "var(--bmt-spacing-space-200)"
  },
  "spacing.space.300": {
    "value": "24px",
    "variable": "var(--bmt-spacing-space-300)"
  },
  "spacing.space.400": {
    "value": "32px",
    "variable": "var(--bmt-spacing-space-400)"
  },
  "spacing.space.500": {
    "value": "40px",
    "variable": "var(--bmt-spacing-space-500)"
  },
  "spacing.space.600": {
    "value": "48px",
    "variable": "var(--bmt-spacing-space-600)"
  },
  "spacing.space.800": {
    "value": "64px",
    "variable": "var(--bmt-spacing-space-800)"
  },
  "zIndex.below": {
    "value": -1,
    "variable": "var(--bmt-z-index-below)"
  },
  "zIndex.default": {
    "value": 1,
    "variable": "var(--bmt-z-index-default)"
  },
  "lineHeights.lineHeight.25": {
    "value": "18px",
    "variable": "var(--bmt-line-heights-line-height-25)"
  },
  "lineHeights.lineHeight.30": {
    "value": "20px",
    "variable": "var(--bmt-line-heights-line-height-30)"
  },
  "lineHeights.lineHeight.50": {
    "value": "21px",
    "variable": "var(--bmt-line-heights-line-height-50)"
  },
  "lineHeights.lineHeight.100": {
    "value": "24px",
    "variable": "var(--bmt-line-heights-line-height-100)"
  },
  "lineHeights.lineHeight.200": {
    "value": "26px",
    "variable": "var(--bmt-line-heights-line-height-200)"
  },
  "lineHeights.lineHeight.300": {
    "value": "34px",
    "variable": "var(--bmt-line-heights-line-height-300)"
  },
  "lineHeights.lineHeight.400": {
    "value": "42px",
    "variable": "var(--bmt-line-heights-line-height-400)"
  },
  "breakpoints.sm": {
    "value": "500px",
    "variable": "var(--bmt-breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "700px",
    "variable": "var(--bmt-breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "964px",
    "variable": "var(--bmt-breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1224px",
    "variable": "var(--bmt-breakpoints-xl)"
  },
  "colors.background": {
    "value": "var(--bmt-colors-background)",
    "variable": "var(--bmt-colors-background)"
  },
  "colors.background.surface": {
    "value": "var(--bmt-colors-background-surface)",
    "variable": "var(--bmt-colors-background-surface)"
  },
  "colors.background.surface.hover": {
    "value": "var(--bmt-colors-background-surface-hover)",
    "variable": "var(--bmt-colors-background-surface-hover)"
  },
  "colors.background.surface.active": {
    "value": "var(--bmt-colors-background-surface-active)",
    "variable": "var(--bmt-colors-background-surface-active)"
  },
  "colors.background.surface.disabled": {
    "value": "var(--bmt-colors-background-surface-disabled)",
    "variable": "var(--bmt-colors-background-surface-disabled)"
  },
  "colors.background.primary": {
    "value": "var(--bmt-colors-background-primary)",
    "variable": "var(--bmt-colors-background-primary)"
  },
  "colors.background.primary.disabled": {
    "value": "var(--bmt-colors-background-primary-disabled)",
    "variable": "var(--bmt-colors-background-primary-disabled)"
  },
  "colors.background.primary.hover": {
    "value": "var(--bmt-colors-background-primary-hover)",
    "variable": "var(--bmt-colors-background-primary-hover)"
  },
  "colors.background.primary.active": {
    "value": "var(--bmt-colors-background-primary-active)",
    "variable": "var(--bmt-colors-background-primary-active)"
  },
  "colors.background.input": {
    "value": "var(--bmt-colors-background-input)",
    "variable": "var(--bmt-colors-background-input)"
  },
  "colors.background.input.disabled": {
    "value": "var(--bmt-colors-background-input-disabled)",
    "variable": "var(--bmt-colors-background-input-disabled)"
  },
  "colors.background.transparent": {
    "value": "var(--bmt-colors-background-transparent)",
    "variable": "var(--bmt-colors-background-transparent)"
  },
  "colors.background.transparent.hover": {
    "value": "var(--bmt-colors-background-transparent-hover)",
    "variable": "var(--bmt-colors-background-transparent-hover)"
  },
  "colors.background.transparent.active": {
    "value": "var(--bmt-colors-background-transparent-active)",
    "variable": "var(--bmt-colors-background-transparent-active)"
  },
  "colors.background.neutral": {
    "value": "var(--bmt-colors-background-neutral)",
    "variable": "var(--bmt-colors-background-neutral)"
  },
  "colors.background.neutral.hover": {
    "value": "var(--bmt-colors-background-neutral-hover)",
    "variable": "var(--bmt-colors-background-neutral-hover)"
  },
  "colors.background.neutral.active": {
    "value": "var(--bmt-colors-background-neutral-active)",
    "variable": "var(--bmt-colors-background-neutral-active)"
  },
  "colors.background.neutral.strong": {
    "value": "var(--bmt-colors-background-neutral-strong)",
    "variable": "var(--bmt-colors-background-neutral-strong)"
  },
  "colors.background.neutral.strong.hover": {
    "value": "var(--bmt-colors-background-neutral-strong-hover)",
    "variable": "var(--bmt-colors-background-neutral-strong-hover)"
  },
  "colors.background.neutral.strong.active": {
    "value": "var(--bmt-colors-background-neutral-strong-active)",
    "variable": "var(--bmt-colors-background-neutral-strong-active)"
  },
  "colors.background.neutral.strongest": {
    "value": "var(--bmt-colors-background-neutral-strongest)",
    "variable": "var(--bmt-colors-background-neutral-strongest)"
  },
  "colors.background.neutral.strongest.hover": {
    "value": "var(--bmt-colors-background-neutral-strongest-hover)",
    "variable": "var(--bmt-colors-background-neutral-strongest-hover)"
  },
  "colors.background.neutral.strongest.active": {
    "value": "var(--bmt-colors-background-neutral-strongest-active)",
    "variable": "var(--bmt-colors-background-neutral-strongest-active)"
  },
  "colors.background.info": {
    "value": "var(--bmt-colors-background-info)",
    "variable": "var(--bmt-colors-background-info)"
  },
  "colors.background.info.strong": {
    "value": "var(--bmt-colors-background-info-strong)",
    "variable": "var(--bmt-colors-background-info-strong)"
  },
  "colors.background.success": {
    "value": "var(--bmt-colors-background-success)",
    "variable": "var(--bmt-colors-background-success)"
  },
  "colors.background.success.strong": {
    "value": "var(--bmt-colors-background-success-strong)",
    "variable": "var(--bmt-colors-background-success-strong)"
  },
  "colors.background.warning": {
    "value": "var(--bmt-colors-background-warning)",
    "variable": "var(--bmt-colors-background-warning)"
  },
  "colors.background.warning.strong": {
    "value": "var(--bmt-colors-background-warning-strong)",
    "variable": "var(--bmt-colors-background-warning-strong)"
  },
  "colors.background.critical": {
    "value": "var(--bmt-colors-background-critical)",
    "variable": "var(--bmt-colors-background-critical)"
  },
  "colors.background.critical.strong": {
    "value": "var(--bmt-colors-background-critical-strong)",
    "variable": "var(--bmt-colors-background-critical-strong)"
  },
  "colors.background.critical.strong.hover": {
    "value": "var(--bmt-colors-background-critical-strong-hover)",
    "variable": "var(--bmt-colors-background-critical-strong-hover)"
  },
  "colors.background.critical.strong.active": {
    "value": "var(--bmt-colors-background-critical-strong-active)",
    "variable": "var(--bmt-colors-background-critical-strong-active)"
  },
  "colors.background.critical.strong.disabled": {
    "value": "var(--bmt-colors-background-critical-strong-disabled)",
    "variable": "var(--bmt-colors-background-critical-strong-disabled)"
  },
  "colors.background.shimmer.base": {
    "value": "var(--bmt-colors-background-shimmer-base)",
    "variable": "var(--bmt-colors-background-shimmer-base)"
  },
  "colors.background.shimmer.highlight": {
    "value": "var(--bmt-colors-background-shimmer-highlight)",
    "variable": "var(--bmt-colors-background-shimmer-highlight)"
  },
  "colors.background.overlay": {
    "value": "var(--bmt-colors-background-overlay)",
    "variable": "var(--bmt-colors-background-overlay)"
  },
  "colors.background.overlay.weak": {
    "value": "var(--bmt-colors-background-overlay-weak)",
    "variable": "var(--bmt-colors-background-overlay-weak)"
  },
  "colors.background.accent.teal": {
    "value": "var(--bmt-colors-background-accent-teal)",
    "variable": "var(--bmt-colors-background-accent-teal)"
  },
  "colors.background.accent.blue": {
    "value": "var(--bmt-colors-background-accent-blue)",
    "variable": "var(--bmt-colors-background-accent-blue)"
  },
  "colors.background.accent.red": {
    "value": "var(--bmt-colors-background-accent-red)",
    "variable": "var(--bmt-colors-background-accent-red)"
  },
  "colors.background.accent.gold": {
    "value": "var(--bmt-colors-background-accent-gold)",
    "variable": "var(--bmt-colors-background-accent-gold)"
  },
  "colors.background.accent.grey": {
    "value": "var(--bmt-colors-background-accent-grey)",
    "variable": "var(--bmt-colors-background-accent-grey)"
  },
  "colors.background.abyss": {
    "value": "var(--bmt-colors-background-abyss)",
    "variable": "var(--bmt-colors-background-abyss)"
  },
  "colors.border": {
    "value": "var(--bmt-colors-border)",
    "variable": "var(--bmt-colors-border)"
  },
  "colors.border.alpha": {
    "value": "var(--bmt-colors-border-alpha)",
    "variable": "var(--bmt-colors-border-alpha)"
  },
  "colors.border.weak": {
    "value": "var(--bmt-colors-border-weak)",
    "variable": "var(--bmt-colors-border-weak)"
  },
  "colors.border.strong": {
    "value": "var(--bmt-colors-border-strong)",
    "variable": "var(--bmt-colors-border-strong)"
  },
  "colors.border.strongest": {
    "value": "var(--bmt-colors-border-strongest)",
    "variable": "var(--bmt-colors-border-strongest)"
  },
  "colors.border.onPrimary": {
    "value": "var(--bmt-colors-border-on-primary)",
    "variable": "var(--bmt-colors-border-on-primary)"
  },
  "colors.border.input": {
    "value": "var(--bmt-colors-border-input)",
    "variable": "var(--bmt-colors-border-input)"
  },
  "colors.border.selected": {
    "value": "var(--bmt-colors-border-selected)",
    "variable": "var(--bmt-colors-border-selected)"
  },
  "colors.border.focused": {
    "value": "var(--bmt-colors-border-focused)",
    "variable": "var(--bmt-colors-border-focused)"
  },
  "colors.border.critical": {
    "value": "var(--bmt-colors-border-critical)",
    "variable": "var(--bmt-colors-border-critical)"
  },
  "colors.dataviz.blue.1": {
    "value": "var(--bmt-colors-dataviz-blue-1)",
    "variable": "var(--bmt-colors-dataviz-blue-1)"
  },
  "colors.dataviz.blue.2": {
    "value": "var(--bmt-colors-dataviz-blue-2)",
    "variable": "var(--bmt-colors-dataviz-blue-2)"
  },
  "colors.dataviz.blue.3": {
    "value": "var(--bmt-colors-dataviz-blue-3)",
    "variable": "var(--bmt-colors-dataviz-blue-3)"
  },
  "colors.dataviz.blue.overlay": {
    "value": "var(--bmt-colors-dataviz-blue-overlay)",
    "variable": "var(--bmt-colors-dataviz-blue-overlay)"
  },
  "colors.dataviz.teal.1": {
    "value": "var(--bmt-colors-dataviz-teal-1)",
    "variable": "var(--bmt-colors-dataviz-teal-1)"
  },
  "colors.dataviz.teal.2": {
    "value": "var(--bmt-colors-dataviz-teal-2)",
    "variable": "var(--bmt-colors-dataviz-teal-2)"
  },
  "colors.dataviz.teal.3": {
    "value": "var(--bmt-colors-dataviz-teal-3)",
    "variable": "var(--bmt-colors-dataviz-teal-3)"
  },
  "colors.dataviz.teal.overlay": {
    "value": "var(--bmt-colors-dataviz-teal-overlay)",
    "variable": "var(--bmt-colors-dataviz-teal-overlay)"
  },
  "colors.dataviz.orange.1": {
    "value": "var(--bmt-colors-dataviz-orange-1)",
    "variable": "var(--bmt-colors-dataviz-orange-1)"
  },
  "colors.dataviz.orange.2": {
    "value": "var(--bmt-colors-dataviz-orange-2)",
    "variable": "var(--bmt-colors-dataviz-orange-2)"
  },
  "colors.dataviz.orange.3": {
    "value": "var(--bmt-colors-dataviz-orange-3)",
    "variable": "var(--bmt-colors-dataviz-orange-3)"
  },
  "colors.dataviz.orange.overlay": {
    "value": "var(--bmt-colors-dataviz-orange-overlay)",
    "variable": "var(--bmt-colors-dataviz-orange-overlay)"
  },
  "colors.dataviz.purple.1": {
    "value": "var(--bmt-colors-dataviz-purple-1)",
    "variable": "var(--bmt-colors-dataviz-purple-1)"
  },
  "colors.dataviz.purple.2": {
    "value": "var(--bmt-colors-dataviz-purple-2)",
    "variable": "var(--bmt-colors-dataviz-purple-2)"
  },
  "colors.dataviz.purple.3": {
    "value": "var(--bmt-colors-dataviz-purple-3)",
    "variable": "var(--bmt-colors-dataviz-purple-3)"
  },
  "colors.dataviz.purple.overlay": {
    "value": "var(--bmt-colors-dataviz-purple-overlay)",
    "variable": "var(--bmt-colors-dataviz-purple-overlay)"
  },
  "colors.dataviz.navy.1": {
    "value": "var(--bmt-colors-dataviz-navy-1)",
    "variable": "var(--bmt-colors-dataviz-navy-1)"
  },
  "colors.dataviz.navy.2": {
    "value": "var(--bmt-colors-dataviz-navy-2)",
    "variable": "var(--bmt-colors-dataviz-navy-2)"
  },
  "colors.dataviz.navy.3": {
    "value": "var(--bmt-colors-dataviz-navy-3)",
    "variable": "var(--bmt-colors-dataviz-navy-3)"
  },
  "colors.dataviz.navy.overlay": {
    "value": "var(--bmt-colors-dataviz-navy-overlay)",
    "variable": "var(--bmt-colors-dataviz-navy-overlay)"
  },
  "colors.icon": {
    "value": "var(--bmt-colors-icon)",
    "variable": "var(--bmt-colors-icon)"
  },
  "colors.icon.weak": {
    "value": "var(--bmt-colors-icon-weak)",
    "variable": "var(--bmt-colors-icon-weak)"
  },
  "colors.icon.weakest": {
    "value": "var(--bmt-colors-icon-weakest)",
    "variable": "var(--bmt-colors-icon-weakest)"
  },
  "colors.icon.disabled": {
    "value": "var(--bmt-colors-icon-disabled)",
    "variable": "var(--bmt-colors-icon-disabled)"
  },
  "colors.icon.onPrimary": {
    "value": "var(--bmt-colors-icon-on-primary)",
    "variable": "var(--bmt-colors-icon-on-primary)"
  },
  "colors.icon.onPrimary.disabled": {
    "value": "var(--bmt-colors-icon-on-primary-disabled)",
    "variable": "var(--bmt-colors-icon-on-primary-disabled)"
  },
  "colors.icon.inverse": {
    "value": "var(--bmt-colors-icon-inverse)",
    "variable": "var(--bmt-colors-icon-inverse)"
  },
  "colors.icon.selected": {
    "value": "var(--bmt-colors-icon-selected)",
    "variable": "var(--bmt-colors-icon-selected)"
  },
  "colors.icon.success": {
    "value": "var(--bmt-colors-icon-success)",
    "variable": "var(--bmt-colors-icon-success)"
  },
  "colors.icon.info": {
    "value": "var(--bmt-colors-icon-info)",
    "variable": "var(--bmt-colors-icon-info)"
  },
  "colors.icon.warning": {
    "value": "var(--bmt-colors-icon-warning)",
    "variable": "var(--bmt-colors-icon-warning)"
  },
  "colors.icon.critical": {
    "value": "var(--bmt-colors-icon-critical)",
    "variable": "var(--bmt-colors-icon-critical)"
  },
  "colors.icon.critical.hover": {
    "value": "var(--bmt-colors-icon-critical-hover)",
    "variable": "var(--bmt-colors-icon-critical-hover)"
  },
  "colors.icon.critical.active": {
    "value": "var(--bmt-colors-icon-critical-active)",
    "variable": "var(--bmt-colors-icon-critical-active)"
  },
  "colors.icon.link": {
    "value": "var(--bmt-colors-icon-link)",
    "variable": "var(--bmt-colors-icon-link)"
  },
  "colors.icon.link.hover": {
    "value": "var(--bmt-colors-icon-link-hover)",
    "variable": "var(--bmt-colors-icon-link-hover)"
  },
  "colors.icon.link.active": {
    "value": "var(--bmt-colors-icon-link-active)",
    "variable": "var(--bmt-colors-icon-link-active)"
  },
  "colors.icon.accent.teal": {
    "value": "var(--bmt-colors-icon-accent-teal)",
    "variable": "var(--bmt-colors-icon-accent-teal)"
  },
  "colors.icon.accent.teal.strong": {
    "value": "var(--bmt-colors-icon-accent-teal-strong)",
    "variable": "var(--bmt-colors-icon-accent-teal-strong)"
  },
  "colors.icon.accent.gold": {
    "value": "var(--bmt-colors-icon-accent-gold)",
    "variable": "var(--bmt-colors-icon-accent-gold)"
  },
  "colors.icon.accent.gold.strong": {
    "value": "var(--bmt-colors-icon-accent-gold-strong)",
    "variable": "var(--bmt-colors-icon-accent-gold-strong)"
  },
  "colors.icon.accent.purple": {
    "value": "var(--bmt-colors-icon-accent-purple)",
    "variable": "var(--bmt-colors-icon-accent-purple)"
  },
  "colors.icon.accent.blue": {
    "value": "var(--bmt-colors-icon-accent-blue)",
    "variable": "var(--bmt-colors-icon-accent-blue)"
  },
  "colors.icon.accent.blue.strong": {
    "value": "var(--bmt-colors-icon-accent-blue-strong)",
    "variable": "var(--bmt-colors-icon-accent-blue-strong)"
  },
  "colors.icon.accent.navy": {
    "value": "var(--bmt-colors-icon-accent-navy)",
    "variable": "var(--bmt-colors-icon-accent-navy)"
  },
  "colors.icon.accent.red": {
    "value": "var(--bmt-colors-icon-accent-red)",
    "variable": "var(--bmt-colors-icon-accent-red)"
  },
  "colors.icon.accent.grey": {
    "value": "var(--bmt-colors-icon-accent-grey)",
    "variable": "var(--bmt-colors-icon-accent-grey)"
  },
  "colors.text": {
    "value": "var(--bmt-colors-text)",
    "variable": "var(--bmt-colors-text)"
  },
  "colors.text.weak": {
    "value": "var(--bmt-colors-text-weak)",
    "variable": "var(--bmt-colors-text-weak)"
  },
  "colors.text.disabled": {
    "value": "var(--bmt-colors-text-disabled)",
    "variable": "var(--bmt-colors-text-disabled)"
  },
  "colors.text.placeholder": {
    "value": "var(--bmt-colors-text-placeholder)",
    "variable": "var(--bmt-colors-text-placeholder)"
  },
  "colors.text.onPrimary": {
    "value": "var(--bmt-colors-text-on-primary)",
    "variable": "var(--bmt-colors-text-on-primary)"
  },
  "colors.text.onPrimary.disabled": {
    "value": "var(--bmt-colors-text-on-primary-disabled)",
    "variable": "var(--bmt-colors-text-on-primary-disabled)"
  },
  "colors.text.inverse": {
    "value": "var(--bmt-colors-text-inverse)",
    "variable": "var(--bmt-colors-text-inverse)"
  },
  "colors.text.selected": {
    "value": "var(--bmt-colors-text-selected)",
    "variable": "var(--bmt-colors-text-selected)"
  },
  "colors.text.success": {
    "value": "var(--bmt-colors-text-success)",
    "variable": "var(--bmt-colors-text-success)"
  },
  "colors.text.info": {
    "value": "var(--bmt-colors-text-info)",
    "variable": "var(--bmt-colors-text-info)"
  },
  "colors.text.warning": {
    "value": "var(--bmt-colors-text-warning)",
    "variable": "var(--bmt-colors-text-warning)"
  },
  "colors.text.critical": {
    "value": "var(--bmt-colors-text-critical)",
    "variable": "var(--bmt-colors-text-critical)"
  },
  "colors.text.critical.hover": {
    "value": "var(--bmt-colors-text-critical-hover)",
    "variable": "var(--bmt-colors-text-critical-hover)"
  },
  "colors.text.critical.active": {
    "value": "var(--bmt-colors-text-critical-active)",
    "variable": "var(--bmt-colors-text-critical-active)"
  },
  "colors.text.link": {
    "value": "var(--bmt-colors-text-link)",
    "variable": "var(--bmt-colors-text-link)"
  },
  "colors.text.link.hover": {
    "value": "var(--bmt-colors-text-link-hover)",
    "variable": "var(--bmt-colors-text-link-hover)"
  },
  "colors.text.link.active": {
    "value": "var(--bmt-colors-text-link-active)",
    "variable": "var(--bmt-colors-text-link-active)"
  },
  "colors.text.accent.teal": {
    "value": "var(--bmt-colors-text-accent-teal)",
    "variable": "var(--bmt-colors-text-accent-teal)"
  },
  "colors.text.accent.blue": {
    "value": "var(--bmt-colors-text-accent-blue)",
    "variable": "var(--bmt-colors-text-accent-blue)"
  },
  "colors.text.accent.red": {
    "value": "var(--bmt-colors-text-accent-red)",
    "variable": "var(--bmt-colors-text-accent-red)"
  },
  "colors.text.accent.gold": {
    "value": "var(--bmt-colors-text-accent-gold)",
    "variable": "var(--bmt-colors-text-accent-gold)"
  },
  "colors.text.accent.grey": {
    "value": "var(--bmt-colors-text-accent-grey)",
    "variable": "var(--bmt-colors-text-accent-grey)"
  },
  "spacing.space.-0": {
    "value": "calc(var(--bmt-spacing-space-0) * -1)",
    "variable": "var(--bmt-spacing-space-0)"
  },
  "spacing.space.-25": {
    "value": "calc(var(--bmt-spacing-space-25) * -1)",
    "variable": "var(--bmt-spacing-space-25)"
  },
  "spacing.space.-50": {
    "value": "calc(var(--bmt-spacing-space-50) * -1)",
    "variable": "var(--bmt-spacing-space-50)"
  },
  "spacing.space.-100": {
    "value": "calc(var(--bmt-spacing-space-100) * -1)",
    "variable": "var(--bmt-spacing-space-100)"
  },
  "spacing.space.-150": {
    "value": "calc(var(--bmt-spacing-space-150) * -1)",
    "variable": "var(--bmt-spacing-space-150)"
  },
  "spacing.space.-200": {
    "value": "calc(var(--bmt-spacing-space-200) * -1)",
    "variable": "var(--bmt-spacing-space-200)"
  },
  "spacing.space.-300": {
    "value": "calc(var(--bmt-spacing-space-300) * -1)",
    "variable": "var(--bmt-spacing-space-300)"
  },
  "spacing.space.-400": {
    "value": "calc(var(--bmt-spacing-space-400) * -1)",
    "variable": "var(--bmt-spacing-space-400)"
  },
  "spacing.space.-500": {
    "value": "calc(var(--bmt-spacing-space-500) * -1)",
    "variable": "var(--bmt-spacing-space-500)"
  },
  "spacing.space.-600": {
    "value": "calc(var(--bmt-spacing-space-600) * -1)",
    "variable": "var(--bmt-spacing-space-600)"
  },
  "spacing.space.-800": {
    "value": "calc(var(--bmt-spacing-space-800) * -1)",
    "variable": "var(--bmt-spacing-space-800)"
  },
  "colors.colorPalette.black": {
    "value": "var(--bmt-colors-color-palette-black)",
    "variable": "var(--bmt-colors-color-palette-black)"
  },
  "colors.colorPalette.blue.10": {
    "value": "var(--bmt-colors-color-palette-blue-10)",
    "variable": "var(--bmt-colors-color-palette-blue-10)"
  },
  "colors.colorPalette.10": {
    "value": "var(--bmt-colors-color-palette-10)",
    "variable": "var(--bmt-colors-color-palette-10)"
  },
  "colors.colorPalette.blue.20": {
    "value": "var(--bmt-colors-color-palette-blue-20)",
    "variable": "var(--bmt-colors-color-palette-blue-20)"
  },
  "colors.colorPalette.20": {
    "value": "var(--bmt-colors-color-palette-20)",
    "variable": "var(--bmt-colors-color-palette-20)"
  },
  "colors.colorPalette.blue.30": {
    "value": "var(--bmt-colors-color-palette-blue-30)",
    "variable": "var(--bmt-colors-color-palette-blue-30)"
  },
  "colors.colorPalette.30": {
    "value": "var(--bmt-colors-color-palette-30)",
    "variable": "var(--bmt-colors-color-palette-30)"
  },
  "colors.colorPalette.blue.40": {
    "value": "var(--bmt-colors-color-palette-blue-40)",
    "variable": "var(--bmt-colors-color-palette-blue-40)"
  },
  "colors.colorPalette.40": {
    "value": "var(--bmt-colors-color-palette-40)",
    "variable": "var(--bmt-colors-color-palette-40)"
  },
  "colors.colorPalette.blue.50": {
    "value": "var(--bmt-colors-color-palette-blue-50)",
    "variable": "var(--bmt-colors-color-palette-blue-50)"
  },
  "colors.colorPalette.50": {
    "value": "var(--bmt-colors-color-palette-50)",
    "variable": "var(--bmt-colors-color-palette-50)"
  },
  "colors.colorPalette.blue.60": {
    "value": "var(--bmt-colors-color-palette-blue-60)",
    "variable": "var(--bmt-colors-color-palette-blue-60)"
  },
  "colors.colorPalette.60": {
    "value": "var(--bmt-colors-color-palette-60)",
    "variable": "var(--bmt-colors-color-palette-60)"
  },
  "colors.colorPalette.blue.70": {
    "value": "var(--bmt-colors-color-palette-blue-70)",
    "variable": "var(--bmt-colors-color-palette-blue-70)"
  },
  "colors.colorPalette.70": {
    "value": "var(--bmt-colors-color-palette-70)",
    "variable": "var(--bmt-colors-color-palette-70)"
  },
  "colors.colorPalette.blue.80": {
    "value": "var(--bmt-colors-color-palette-blue-80)",
    "variable": "var(--bmt-colors-color-palette-blue-80)"
  },
  "colors.colorPalette.80": {
    "value": "var(--bmt-colors-color-palette-80)",
    "variable": "var(--bmt-colors-color-palette-80)"
  },
  "colors.colorPalette.blue.90": {
    "value": "var(--bmt-colors-color-palette-blue-90)",
    "variable": "var(--bmt-colors-color-palette-blue-90)"
  },
  "colors.colorPalette.90": {
    "value": "var(--bmt-colors-color-palette-90)",
    "variable": "var(--bmt-colors-color-palette-90)"
  },
  "colors.colorPalette.blue.100": {
    "value": "var(--bmt-colors-color-palette-blue-100)",
    "variable": "var(--bmt-colors-color-palette-blue-100)"
  },
  "colors.colorPalette.100": {
    "value": "var(--bmt-colors-color-palette-100)",
    "variable": "var(--bmt-colors-color-palette-100)"
  },
  "colors.colorPalette.blue.60alpha30": {
    "value": "var(--bmt-colors-color-palette-blue-60alpha30)",
    "variable": "var(--bmt-colors-color-palette-blue-60alpha30)"
  },
  "colors.colorPalette.60alpha30": {
    "value": "var(--bmt-colors-color-palette-60alpha30)",
    "variable": "var(--bmt-colors-color-palette-60alpha30)"
  },
  "colors.colorPalette.blue.60alpha40": {
    "value": "var(--bmt-colors-color-palette-blue-60alpha40)",
    "variable": "var(--bmt-colors-color-palette-blue-60alpha40)"
  },
  "colors.colorPalette.60alpha40": {
    "value": "var(--bmt-colors-color-palette-60alpha40)",
    "variable": "var(--bmt-colors-color-palette-60alpha40)"
  },
  "colors.colorPalette.gold.10": {
    "value": "var(--bmt-colors-color-palette-gold-10)",
    "variable": "var(--bmt-colors-color-palette-gold-10)"
  },
  "colors.colorPalette.gold.20": {
    "value": "var(--bmt-colors-color-palette-gold-20)",
    "variable": "var(--bmt-colors-color-palette-gold-20)"
  },
  "colors.colorPalette.gold.30": {
    "value": "var(--bmt-colors-color-palette-gold-30)",
    "variable": "var(--bmt-colors-color-palette-gold-30)"
  },
  "colors.colorPalette.gold.40": {
    "value": "var(--bmt-colors-color-palette-gold-40)",
    "variable": "var(--bmt-colors-color-palette-gold-40)"
  },
  "colors.colorPalette.gold.50": {
    "value": "var(--bmt-colors-color-palette-gold-50)",
    "variable": "var(--bmt-colors-color-palette-gold-50)"
  },
  "colors.colorPalette.gold.60": {
    "value": "var(--bmt-colors-color-palette-gold-60)",
    "variable": "var(--bmt-colors-color-palette-gold-60)"
  },
  "colors.colorPalette.gold.70": {
    "value": "var(--bmt-colors-color-palette-gold-70)",
    "variable": "var(--bmt-colors-color-palette-gold-70)"
  },
  "colors.colorPalette.gold.80": {
    "value": "var(--bmt-colors-color-palette-gold-80)",
    "variable": "var(--bmt-colors-color-palette-gold-80)"
  },
  "colors.colorPalette.gold.90": {
    "value": "var(--bmt-colors-color-palette-gold-90)",
    "variable": "var(--bmt-colors-color-palette-gold-90)"
  },
  "colors.colorPalette.gold.100": {
    "value": "var(--bmt-colors-color-palette-gold-100)",
    "variable": "var(--bmt-colors-color-palette-gold-100)"
  },
  "colors.colorPalette.grey.10": {
    "value": "var(--bmt-colors-color-palette-grey-10)",
    "variable": "var(--bmt-colors-color-palette-grey-10)"
  },
  "colors.colorPalette.grey.20": {
    "value": "var(--bmt-colors-color-palette-grey-20)",
    "variable": "var(--bmt-colors-color-palette-grey-20)"
  },
  "colors.colorPalette.grey.30": {
    "value": "var(--bmt-colors-color-palette-grey-30)",
    "variable": "var(--bmt-colors-color-palette-grey-30)"
  },
  "colors.colorPalette.grey.40": {
    "value": "var(--bmt-colors-color-palette-grey-40)",
    "variable": "var(--bmt-colors-color-palette-grey-40)"
  },
  "colors.colorPalette.grey.50": {
    "value": "var(--bmt-colors-color-palette-grey-50)",
    "variable": "var(--bmt-colors-color-palette-grey-50)"
  },
  "colors.colorPalette.grey.60": {
    "value": "var(--bmt-colors-color-palette-grey-60)",
    "variable": "var(--bmt-colors-color-palette-grey-60)"
  },
  "colors.colorPalette.grey.70": {
    "value": "var(--bmt-colors-color-palette-grey-70)",
    "variable": "var(--bmt-colors-color-palette-grey-70)"
  },
  "colors.colorPalette.grey.80": {
    "value": "var(--bmt-colors-color-palette-grey-80)",
    "variable": "var(--bmt-colors-color-palette-grey-80)"
  },
  "colors.colorPalette.grey.90": {
    "value": "var(--bmt-colors-color-palette-grey-90)",
    "variable": "var(--bmt-colors-color-palette-grey-90)"
  },
  "colors.colorPalette.grey.100": {
    "value": "var(--bmt-colors-color-palette-grey-100)",
    "variable": "var(--bmt-colors-color-palette-grey-100)"
  },
  "colors.colorPalette.grey.90alpha05": {
    "value": "var(--bmt-colors-color-palette-grey-90alpha05)",
    "variable": "var(--bmt-colors-color-palette-grey-90alpha05)"
  },
  "colors.colorPalette.90alpha05": {
    "value": "var(--bmt-colors-color-palette-90alpha05)",
    "variable": "var(--bmt-colors-color-palette-90alpha05)"
  },
  "colors.colorPalette.grey.90alpha10": {
    "value": "var(--bmt-colors-color-palette-grey-90alpha10)",
    "variable": "var(--bmt-colors-color-palette-grey-90alpha10)"
  },
  "colors.colorPalette.90alpha10": {
    "value": "var(--bmt-colors-color-palette-90alpha10)",
    "variable": "var(--bmt-colors-color-palette-90alpha10)"
  },
  "colors.colorPalette.grey.90alpha15": {
    "value": "var(--bmt-colors-color-palette-grey-90alpha15)",
    "variable": "var(--bmt-colors-color-palette-grey-90alpha15)"
  },
  "colors.colorPalette.90alpha15": {
    "value": "var(--bmt-colors-color-palette-90alpha15)",
    "variable": "var(--bmt-colors-color-palette-90alpha15)"
  },
  "colors.colorPalette.grey.90alpha40": {
    "value": "var(--bmt-colors-color-palette-grey-90alpha40)",
    "variable": "var(--bmt-colors-color-palette-grey-90alpha40)"
  },
  "colors.colorPalette.90alpha40": {
    "value": "var(--bmt-colors-color-palette-90alpha40)",
    "variable": "var(--bmt-colors-color-palette-90alpha40)"
  },
  "colors.colorPalette.grey.90alpha80": {
    "value": "var(--bmt-colors-color-palette-grey-90alpha80)",
    "variable": "var(--bmt-colors-color-palette-grey-90alpha80)"
  },
  "colors.colorPalette.90alpha80": {
    "value": "var(--bmt-colors-color-palette-90alpha80)",
    "variable": "var(--bmt-colors-color-palette-90alpha80)"
  },
  "colors.colorPalette.navy.10": {
    "value": "var(--bmt-colors-color-palette-navy-10)",
    "variable": "var(--bmt-colors-color-palette-navy-10)"
  },
  "colors.colorPalette.navy.20": {
    "value": "var(--bmt-colors-color-palette-navy-20)",
    "variable": "var(--bmt-colors-color-palette-navy-20)"
  },
  "colors.colorPalette.navy.30": {
    "value": "var(--bmt-colors-color-palette-navy-30)",
    "variable": "var(--bmt-colors-color-palette-navy-30)"
  },
  "colors.colorPalette.navy.40": {
    "value": "var(--bmt-colors-color-palette-navy-40)",
    "variable": "var(--bmt-colors-color-palette-navy-40)"
  },
  "colors.colorPalette.navy.50": {
    "value": "var(--bmt-colors-color-palette-navy-50)",
    "variable": "var(--bmt-colors-color-palette-navy-50)"
  },
  "colors.colorPalette.navy.60": {
    "value": "var(--bmt-colors-color-palette-navy-60)",
    "variable": "var(--bmt-colors-color-palette-navy-60)"
  },
  "colors.colorPalette.navy.70": {
    "value": "var(--bmt-colors-color-palette-navy-70)",
    "variable": "var(--bmt-colors-color-palette-navy-70)"
  },
  "colors.colorPalette.navy.80": {
    "value": "var(--bmt-colors-color-palette-navy-80)",
    "variable": "var(--bmt-colors-color-palette-navy-80)"
  },
  "colors.colorPalette.navy.90": {
    "value": "var(--bmt-colors-color-palette-navy-90)",
    "variable": "var(--bmt-colors-color-palette-navy-90)"
  },
  "colors.colorPalette.navy.100": {
    "value": "var(--bmt-colors-color-palette-navy-100)",
    "variable": "var(--bmt-colors-color-palette-navy-100)"
  },
  "colors.colorPalette.navy.40alpha30": {
    "value": "var(--bmt-colors-color-palette-navy-40alpha30)",
    "variable": "var(--bmt-colors-color-palette-navy-40alpha30)"
  },
  "colors.colorPalette.40alpha30": {
    "value": "var(--bmt-colors-color-palette-40alpha30)",
    "variable": "var(--bmt-colors-color-palette-40alpha30)"
  },
  "colors.colorPalette.orange.10": {
    "value": "var(--bmt-colors-color-palette-orange-10)",
    "variable": "var(--bmt-colors-color-palette-orange-10)"
  },
  "colors.colorPalette.orange.20": {
    "value": "var(--bmt-colors-color-palette-orange-20)",
    "variable": "var(--bmt-colors-color-palette-orange-20)"
  },
  "colors.colorPalette.orange.30": {
    "value": "var(--bmt-colors-color-palette-orange-30)",
    "variable": "var(--bmt-colors-color-palette-orange-30)"
  },
  "colors.colorPalette.orange.40": {
    "value": "var(--bmt-colors-color-palette-orange-40)",
    "variable": "var(--bmt-colors-color-palette-orange-40)"
  },
  "colors.colorPalette.orange.50": {
    "value": "var(--bmt-colors-color-palette-orange-50)",
    "variable": "var(--bmt-colors-color-palette-orange-50)"
  },
  "colors.colorPalette.orange.60": {
    "value": "var(--bmt-colors-color-palette-orange-60)",
    "variable": "var(--bmt-colors-color-palette-orange-60)"
  },
  "colors.colorPalette.orange.70": {
    "value": "var(--bmt-colors-color-palette-orange-70)",
    "variable": "var(--bmt-colors-color-palette-orange-70)"
  },
  "colors.colorPalette.orange.80": {
    "value": "var(--bmt-colors-color-palette-orange-80)",
    "variable": "var(--bmt-colors-color-palette-orange-80)"
  },
  "colors.colorPalette.orange.90": {
    "value": "var(--bmt-colors-color-palette-orange-90)",
    "variable": "var(--bmt-colors-color-palette-orange-90)"
  },
  "colors.colorPalette.orange.100": {
    "value": "var(--bmt-colors-color-palette-orange-100)",
    "variable": "var(--bmt-colors-color-palette-orange-100)"
  },
  "colors.colorPalette.orange.60alpha30": {
    "value": "var(--bmt-colors-color-palette-orange-60alpha30)",
    "variable": "var(--bmt-colors-color-palette-orange-60alpha30)"
  },
  "colors.colorPalette.purple.10": {
    "value": "var(--bmt-colors-color-palette-purple-10)",
    "variable": "var(--bmt-colors-color-palette-purple-10)"
  },
  "colors.colorPalette.purple.20": {
    "value": "var(--bmt-colors-color-palette-purple-20)",
    "variable": "var(--bmt-colors-color-palette-purple-20)"
  },
  "colors.colorPalette.purple.30": {
    "value": "var(--bmt-colors-color-palette-purple-30)",
    "variable": "var(--bmt-colors-color-palette-purple-30)"
  },
  "colors.colorPalette.purple.40": {
    "value": "var(--bmt-colors-color-palette-purple-40)",
    "variable": "var(--bmt-colors-color-palette-purple-40)"
  },
  "colors.colorPalette.purple.50": {
    "value": "var(--bmt-colors-color-palette-purple-50)",
    "variable": "var(--bmt-colors-color-palette-purple-50)"
  },
  "colors.colorPalette.purple.60": {
    "value": "var(--bmt-colors-color-palette-purple-60)",
    "variable": "var(--bmt-colors-color-palette-purple-60)"
  },
  "colors.colorPalette.purple.70": {
    "value": "var(--bmt-colors-color-palette-purple-70)",
    "variable": "var(--bmt-colors-color-palette-purple-70)"
  },
  "colors.colorPalette.purple.80": {
    "value": "var(--bmt-colors-color-palette-purple-80)",
    "variable": "var(--bmt-colors-color-palette-purple-80)"
  },
  "colors.colorPalette.purple.90": {
    "value": "var(--bmt-colors-color-palette-purple-90)",
    "variable": "var(--bmt-colors-color-palette-purple-90)"
  },
  "colors.colorPalette.purple.100": {
    "value": "var(--bmt-colors-color-palette-purple-100)",
    "variable": "var(--bmt-colors-color-palette-purple-100)"
  },
  "colors.colorPalette.purple.50alpha30": {
    "value": "var(--bmt-colors-color-palette-purple-50alpha30)",
    "variable": "var(--bmt-colors-color-palette-purple-50alpha30)"
  },
  "colors.colorPalette.50alpha30": {
    "value": "var(--bmt-colors-color-palette-50alpha30)",
    "variable": "var(--bmt-colors-color-palette-50alpha30)"
  },
  "colors.colorPalette.teal.10": {
    "value": "var(--bmt-colors-color-palette-teal-10)",
    "variable": "var(--bmt-colors-color-palette-teal-10)"
  },
  "colors.colorPalette.teal.20": {
    "value": "var(--bmt-colors-color-palette-teal-20)",
    "variable": "var(--bmt-colors-color-palette-teal-20)"
  },
  "colors.colorPalette.teal.30": {
    "value": "var(--bmt-colors-color-palette-teal-30)",
    "variable": "var(--bmt-colors-color-palette-teal-30)"
  },
  "colors.colorPalette.teal.40": {
    "value": "var(--bmt-colors-color-palette-teal-40)",
    "variable": "var(--bmt-colors-color-palette-teal-40)"
  },
  "colors.colorPalette.teal.50": {
    "value": "var(--bmt-colors-color-palette-teal-50)",
    "variable": "var(--bmt-colors-color-palette-teal-50)"
  },
  "colors.colorPalette.teal.60": {
    "value": "var(--bmt-colors-color-palette-teal-60)",
    "variable": "var(--bmt-colors-color-palette-teal-60)"
  },
  "colors.colorPalette.teal.70": {
    "value": "var(--bmt-colors-color-palette-teal-70)",
    "variable": "var(--bmt-colors-color-palette-teal-70)"
  },
  "colors.colorPalette.teal.80": {
    "value": "var(--bmt-colors-color-palette-teal-80)",
    "variable": "var(--bmt-colors-color-palette-teal-80)"
  },
  "colors.colorPalette.teal.90": {
    "value": "var(--bmt-colors-color-palette-teal-90)",
    "variable": "var(--bmt-colors-color-palette-teal-90)"
  },
  "colors.colorPalette.teal.100": {
    "value": "var(--bmt-colors-color-palette-teal-100)",
    "variable": "var(--bmt-colors-color-palette-teal-100)"
  },
  "colors.colorPalette.teal.60alpha20": {
    "value": "var(--bmt-colors-color-palette-teal-60alpha20)",
    "variable": "var(--bmt-colors-color-palette-teal-60alpha20)"
  },
  "colors.colorPalette.60alpha20": {
    "value": "var(--bmt-colors-color-palette-60alpha20)",
    "variable": "var(--bmt-colors-color-palette-60alpha20)"
  },
  "colors.colorPalette.transparent": {
    "value": "var(--bmt-colors-color-palette-transparent)",
    "variable": "var(--bmt-colors-color-palette-transparent)"
  },
  "colors.colorPalette.red.10": {
    "value": "var(--bmt-colors-color-palette-red-10)",
    "variable": "var(--bmt-colors-color-palette-red-10)"
  },
  "colors.colorPalette.red.20": {
    "value": "var(--bmt-colors-color-palette-red-20)",
    "variable": "var(--bmt-colors-color-palette-red-20)"
  },
  "colors.colorPalette.red.30": {
    "value": "var(--bmt-colors-color-palette-red-30)",
    "variable": "var(--bmt-colors-color-palette-red-30)"
  },
  "colors.colorPalette.red.40": {
    "value": "var(--bmt-colors-color-palette-red-40)",
    "variable": "var(--bmt-colors-color-palette-red-40)"
  },
  "colors.colorPalette.red.50": {
    "value": "var(--bmt-colors-color-palette-red-50)",
    "variable": "var(--bmt-colors-color-palette-red-50)"
  },
  "colors.colorPalette.red.60": {
    "value": "var(--bmt-colors-color-palette-red-60)",
    "variable": "var(--bmt-colors-color-palette-red-60)"
  },
  "colors.colorPalette.red.70": {
    "value": "var(--bmt-colors-color-palette-red-70)",
    "variable": "var(--bmt-colors-color-palette-red-70)"
  },
  "colors.colorPalette.red.80": {
    "value": "var(--bmt-colors-color-palette-red-80)",
    "variable": "var(--bmt-colors-color-palette-red-80)"
  },
  "colors.colorPalette.red.90": {
    "value": "var(--bmt-colors-color-palette-red-90)",
    "variable": "var(--bmt-colors-color-palette-red-90)"
  },
  "colors.colorPalette.red.100": {
    "value": "var(--bmt-colors-color-palette-red-100)",
    "variable": "var(--bmt-colors-color-palette-red-100)"
  },
  "colors.colorPalette.red.70alpha40": {
    "value": "var(--bmt-colors-color-palette-red-70alpha40)",
    "variable": "var(--bmt-colors-color-palette-red-70alpha40)"
  },
  "colors.colorPalette.70alpha40": {
    "value": "var(--bmt-colors-color-palette-70alpha40)",
    "variable": "var(--bmt-colors-color-palette-70alpha40)"
  },
  "colors.colorPalette.white.100": {
    "value": "var(--bmt-colors-color-palette-white-100)",
    "variable": "var(--bmt-colors-color-palette-white-100)"
  },
  "colors.colorPalette.white.100alpha05": {
    "value": "var(--bmt-colors-color-palette-white-100alpha05)",
    "variable": "var(--bmt-colors-color-palette-white-100alpha05)"
  },
  "colors.colorPalette.100alpha05": {
    "value": "var(--bmt-colors-color-palette-100alpha05)",
    "variable": "var(--bmt-colors-color-palette-100alpha05)"
  },
  "colors.colorPalette.white.100alpha10": {
    "value": "var(--bmt-colors-color-palette-white-100alpha10)",
    "variable": "var(--bmt-colors-color-palette-white-100alpha10)"
  },
  "colors.colorPalette.100alpha10": {
    "value": "var(--bmt-colors-color-palette-100alpha10)",
    "variable": "var(--bmt-colors-color-palette-100alpha10)"
  },
  "colors.colorPalette.white.100alpha15": {
    "value": "var(--bmt-colors-color-palette-white-100alpha15)",
    "variable": "var(--bmt-colors-color-palette-white-100alpha15)"
  },
  "colors.colorPalette.100alpha15": {
    "value": "var(--bmt-colors-color-palette-100alpha15)",
    "variable": "var(--bmt-colors-color-palette-100alpha15)"
  },
  "colors.colorPalette.white.100alpha30": {
    "value": "var(--bmt-colors-color-palette-white-100alpha30)",
    "variable": "var(--bmt-colors-color-palette-white-100alpha30)"
  },
  "colors.colorPalette.100alpha30": {
    "value": "var(--bmt-colors-color-palette-100alpha30)",
    "variable": "var(--bmt-colors-color-palette-100alpha30)"
  },
  "colors.colorPalette.white.100alpha40": {
    "value": "var(--bmt-colors-color-palette-white-100alpha40)",
    "variable": "var(--bmt-colors-color-palette-white-100alpha40)"
  },
  "colors.colorPalette.100alpha40": {
    "value": "var(--bmt-colors-color-palette-100alpha40)",
    "variable": "var(--bmt-colors-color-palette-100alpha40)"
  },
  "colors.colorPalette.white.100alpha60": {
    "value": "var(--bmt-colors-color-palette-white-100alpha60)",
    "variable": "var(--bmt-colors-color-palette-white-100alpha60)"
  },
  "colors.colorPalette.100alpha60": {
    "value": "var(--bmt-colors-color-palette-100alpha60)",
    "variable": "var(--bmt-colors-color-palette-100alpha60)"
  },
  "colors.colorPalette": {
    "value": "var(--bmt-colors-color-palette)",
    "variable": "var(--bmt-colors-color-palette)"
  },
  "colors.colorPalette.surface": {
    "value": "var(--bmt-colors-color-palette-surface)",
    "variable": "var(--bmt-colors-color-palette-surface)"
  },
  "colors.colorPalette.surface.hover": {
    "value": "var(--bmt-colors-color-palette-surface-hover)",
    "variable": "var(--bmt-colors-color-palette-surface-hover)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--bmt-colors-color-palette-hover)",
    "variable": "var(--bmt-colors-color-palette-hover)"
  },
  "colors.colorPalette.surface.active": {
    "value": "var(--bmt-colors-color-palette-surface-active)",
    "variable": "var(--bmt-colors-color-palette-surface-active)"
  },
  "colors.colorPalette.active": {
    "value": "var(--bmt-colors-color-palette-active)",
    "variable": "var(--bmt-colors-color-palette-active)"
  },
  "colors.colorPalette.surface.disabled": {
    "value": "var(--bmt-colors-color-palette-surface-disabled)",
    "variable": "var(--bmt-colors-color-palette-surface-disabled)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--bmt-colors-color-palette-disabled)",
    "variable": "var(--bmt-colors-color-palette-disabled)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--bmt-colors-color-palette-primary)",
    "variable": "var(--bmt-colors-color-palette-primary)"
  },
  "colors.colorPalette.primary.disabled": {
    "value": "var(--bmt-colors-color-palette-primary-disabled)",
    "variable": "var(--bmt-colors-color-palette-primary-disabled)"
  },
  "colors.colorPalette.primary.hover": {
    "value": "var(--bmt-colors-color-palette-primary-hover)",
    "variable": "var(--bmt-colors-color-palette-primary-hover)"
  },
  "colors.colorPalette.primary.active": {
    "value": "var(--bmt-colors-color-palette-primary-active)",
    "variable": "var(--bmt-colors-color-palette-primary-active)"
  },
  "colors.colorPalette.input": {
    "value": "var(--bmt-colors-color-palette-input)",
    "variable": "var(--bmt-colors-color-palette-input)"
  },
  "colors.colorPalette.input.disabled": {
    "value": "var(--bmt-colors-color-palette-input-disabled)",
    "variable": "var(--bmt-colors-color-palette-input-disabled)"
  },
  "colors.colorPalette.transparent.hover": {
    "value": "var(--bmt-colors-color-palette-transparent-hover)",
    "variable": "var(--bmt-colors-color-palette-transparent-hover)"
  },
  "colors.colorPalette.transparent.active": {
    "value": "var(--bmt-colors-color-palette-transparent-active)",
    "variable": "var(--bmt-colors-color-palette-transparent-active)"
  },
  "colors.colorPalette.neutral": {
    "value": "var(--bmt-colors-color-palette-neutral)",
    "variable": "var(--bmt-colors-color-palette-neutral)"
  },
  "colors.colorPalette.neutral.hover": {
    "value": "var(--bmt-colors-color-palette-neutral-hover)",
    "variable": "var(--bmt-colors-color-palette-neutral-hover)"
  },
  "colors.colorPalette.neutral.active": {
    "value": "var(--bmt-colors-color-palette-neutral-active)",
    "variable": "var(--bmt-colors-color-palette-neutral-active)"
  },
  "colors.colorPalette.neutral.strong": {
    "value": "var(--bmt-colors-color-palette-neutral-strong)",
    "variable": "var(--bmt-colors-color-palette-neutral-strong)"
  },
  "colors.colorPalette.strong": {
    "value": "var(--bmt-colors-color-palette-strong)",
    "variable": "var(--bmt-colors-color-palette-strong)"
  },
  "colors.colorPalette.neutral.strong.hover": {
    "value": "var(--bmt-colors-color-palette-neutral-strong-hover)",
    "variable": "var(--bmt-colors-color-palette-neutral-strong-hover)"
  },
  "colors.colorPalette.strong.hover": {
    "value": "var(--bmt-colors-color-palette-strong-hover)",
    "variable": "var(--bmt-colors-color-palette-strong-hover)"
  },
  "colors.colorPalette.neutral.strong.active": {
    "value": "var(--bmt-colors-color-palette-neutral-strong-active)",
    "variable": "var(--bmt-colors-color-palette-neutral-strong-active)"
  },
  "colors.colorPalette.strong.active": {
    "value": "var(--bmt-colors-color-palette-strong-active)",
    "variable": "var(--bmt-colors-color-palette-strong-active)"
  },
  "colors.colorPalette.neutral.strongest": {
    "value": "var(--bmt-colors-color-palette-neutral-strongest)",
    "variable": "var(--bmt-colors-color-palette-neutral-strongest)"
  },
  "colors.colorPalette.strongest": {
    "value": "var(--bmt-colors-color-palette-strongest)",
    "variable": "var(--bmt-colors-color-palette-strongest)"
  },
  "colors.colorPalette.neutral.strongest.hover": {
    "value": "var(--bmt-colors-color-palette-neutral-strongest-hover)",
    "variable": "var(--bmt-colors-color-palette-neutral-strongest-hover)"
  },
  "colors.colorPalette.strongest.hover": {
    "value": "var(--bmt-colors-color-palette-strongest-hover)",
    "variable": "var(--bmt-colors-color-palette-strongest-hover)"
  },
  "colors.colorPalette.neutral.strongest.active": {
    "value": "var(--bmt-colors-color-palette-neutral-strongest-active)",
    "variable": "var(--bmt-colors-color-palette-neutral-strongest-active)"
  },
  "colors.colorPalette.strongest.active": {
    "value": "var(--bmt-colors-color-palette-strongest-active)",
    "variable": "var(--bmt-colors-color-palette-strongest-active)"
  },
  "colors.colorPalette.info": {
    "value": "var(--bmt-colors-color-palette-info)",
    "variable": "var(--bmt-colors-color-palette-info)"
  },
  "colors.colorPalette.info.strong": {
    "value": "var(--bmt-colors-color-palette-info-strong)",
    "variable": "var(--bmt-colors-color-palette-info-strong)"
  },
  "colors.colorPalette.success": {
    "value": "var(--bmt-colors-color-palette-success)",
    "variable": "var(--bmt-colors-color-palette-success)"
  },
  "colors.colorPalette.success.strong": {
    "value": "var(--bmt-colors-color-palette-success-strong)",
    "variable": "var(--bmt-colors-color-palette-success-strong)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--bmt-colors-color-palette-warning)",
    "variable": "var(--bmt-colors-color-palette-warning)"
  },
  "colors.colorPalette.warning.strong": {
    "value": "var(--bmt-colors-color-palette-warning-strong)",
    "variable": "var(--bmt-colors-color-palette-warning-strong)"
  },
  "colors.colorPalette.critical": {
    "value": "var(--bmt-colors-color-palette-critical)",
    "variable": "var(--bmt-colors-color-palette-critical)"
  },
  "colors.colorPalette.critical.strong": {
    "value": "var(--bmt-colors-color-palette-critical-strong)",
    "variable": "var(--bmt-colors-color-palette-critical-strong)"
  },
  "colors.colorPalette.critical.strong.hover": {
    "value": "var(--bmt-colors-color-palette-critical-strong-hover)",
    "variable": "var(--bmt-colors-color-palette-critical-strong-hover)"
  },
  "colors.colorPalette.critical.strong.active": {
    "value": "var(--bmt-colors-color-palette-critical-strong-active)",
    "variable": "var(--bmt-colors-color-palette-critical-strong-active)"
  },
  "colors.colorPalette.critical.strong.disabled": {
    "value": "var(--bmt-colors-color-palette-critical-strong-disabled)",
    "variable": "var(--bmt-colors-color-palette-critical-strong-disabled)"
  },
  "colors.colorPalette.strong.disabled": {
    "value": "var(--bmt-colors-color-palette-strong-disabled)",
    "variable": "var(--bmt-colors-color-palette-strong-disabled)"
  },
  "colors.colorPalette.shimmer.base": {
    "value": "var(--bmt-colors-color-palette-shimmer-base)",
    "variable": "var(--bmt-colors-color-palette-shimmer-base)"
  },
  "colors.colorPalette.base": {
    "value": "var(--bmt-colors-color-palette-base)",
    "variable": "var(--bmt-colors-color-palette-base)"
  },
  "colors.colorPalette.shimmer.highlight": {
    "value": "var(--bmt-colors-color-palette-shimmer-highlight)",
    "variable": "var(--bmt-colors-color-palette-shimmer-highlight)"
  },
  "colors.colorPalette.highlight": {
    "value": "var(--bmt-colors-color-palette-highlight)",
    "variable": "var(--bmt-colors-color-palette-highlight)"
  },
  "colors.colorPalette.overlay": {
    "value": "var(--bmt-colors-color-palette-overlay)",
    "variable": "var(--bmt-colors-color-palette-overlay)"
  },
  "colors.colorPalette.overlay.weak": {
    "value": "var(--bmt-colors-color-palette-overlay-weak)",
    "variable": "var(--bmt-colors-color-palette-overlay-weak)"
  },
  "colors.colorPalette.weak": {
    "value": "var(--bmt-colors-color-palette-weak)",
    "variable": "var(--bmt-colors-color-palette-weak)"
  },
  "colors.colorPalette.accent.teal": {
    "value": "var(--bmt-colors-color-palette-accent-teal)",
    "variable": "var(--bmt-colors-color-palette-accent-teal)"
  },
  "colors.colorPalette.teal": {
    "value": "var(--bmt-colors-color-palette-teal)",
    "variable": "var(--bmt-colors-color-palette-teal)"
  },
  "colors.colorPalette.accent.blue": {
    "value": "var(--bmt-colors-color-palette-accent-blue)",
    "variable": "var(--bmt-colors-color-palette-accent-blue)"
  },
  "colors.colorPalette.blue": {
    "value": "var(--bmt-colors-color-palette-blue)",
    "variable": "var(--bmt-colors-color-palette-blue)"
  },
  "colors.colorPalette.accent.red": {
    "value": "var(--bmt-colors-color-palette-accent-red)",
    "variable": "var(--bmt-colors-color-palette-accent-red)"
  },
  "colors.colorPalette.red": {
    "value": "var(--bmt-colors-color-palette-red)",
    "variable": "var(--bmt-colors-color-palette-red)"
  },
  "colors.colorPalette.accent.gold": {
    "value": "var(--bmt-colors-color-palette-accent-gold)",
    "variable": "var(--bmt-colors-color-palette-accent-gold)"
  },
  "colors.colorPalette.gold": {
    "value": "var(--bmt-colors-color-palette-gold)",
    "variable": "var(--bmt-colors-color-palette-gold)"
  },
  "colors.colorPalette.accent.grey": {
    "value": "var(--bmt-colors-color-palette-accent-grey)",
    "variable": "var(--bmt-colors-color-palette-accent-grey)"
  },
  "colors.colorPalette.grey": {
    "value": "var(--bmt-colors-color-palette-grey)",
    "variable": "var(--bmt-colors-color-palette-grey)"
  },
  "colors.colorPalette.abyss": {
    "value": "var(--bmt-colors-color-palette-abyss)",
    "variable": "var(--bmt-colors-color-palette-abyss)"
  },
  "colors.colorPalette.alpha": {
    "value": "var(--bmt-colors-color-palette-alpha)",
    "variable": "var(--bmt-colors-color-palette-alpha)"
  },
  "colors.colorPalette.onPrimary": {
    "value": "var(--bmt-colors-color-palette-on-primary)",
    "variable": "var(--bmt-colors-color-palette-on-primary)"
  },
  "colors.colorPalette.selected": {
    "value": "var(--bmt-colors-color-palette-selected)",
    "variable": "var(--bmt-colors-color-palette-selected)"
  },
  "colors.colorPalette.focused": {
    "value": "var(--bmt-colors-color-palette-focused)",
    "variable": "var(--bmt-colors-color-palette-focused)"
  },
  "colors.colorPalette.blue.1": {
    "value": "var(--bmt-colors-color-palette-blue-1)",
    "variable": "var(--bmt-colors-color-palette-blue-1)"
  },
  "colors.colorPalette.1": {
    "value": "var(--bmt-colors-color-palette-1)",
    "variable": "var(--bmt-colors-color-palette-1)"
  },
  "colors.colorPalette.blue.2": {
    "value": "var(--bmt-colors-color-palette-blue-2)",
    "variable": "var(--bmt-colors-color-palette-blue-2)"
  },
  "colors.colorPalette.2": {
    "value": "var(--bmt-colors-color-palette-2)",
    "variable": "var(--bmt-colors-color-palette-2)"
  },
  "colors.colorPalette.blue.3": {
    "value": "var(--bmt-colors-color-palette-blue-3)",
    "variable": "var(--bmt-colors-color-palette-blue-3)"
  },
  "colors.colorPalette.3": {
    "value": "var(--bmt-colors-color-palette-3)",
    "variable": "var(--bmt-colors-color-palette-3)"
  },
  "colors.colorPalette.blue.overlay": {
    "value": "var(--bmt-colors-color-palette-blue-overlay)",
    "variable": "var(--bmt-colors-color-palette-blue-overlay)"
  },
  "colors.colorPalette.teal.1": {
    "value": "var(--bmt-colors-color-palette-teal-1)",
    "variable": "var(--bmt-colors-color-palette-teal-1)"
  },
  "colors.colorPalette.teal.2": {
    "value": "var(--bmt-colors-color-palette-teal-2)",
    "variable": "var(--bmt-colors-color-palette-teal-2)"
  },
  "colors.colorPalette.teal.3": {
    "value": "var(--bmt-colors-color-palette-teal-3)",
    "variable": "var(--bmt-colors-color-palette-teal-3)"
  },
  "colors.colorPalette.teal.overlay": {
    "value": "var(--bmt-colors-color-palette-teal-overlay)",
    "variable": "var(--bmt-colors-color-palette-teal-overlay)"
  },
  "colors.colorPalette.orange.1": {
    "value": "var(--bmt-colors-color-palette-orange-1)",
    "variable": "var(--bmt-colors-color-palette-orange-1)"
  },
  "colors.colorPalette.orange.2": {
    "value": "var(--bmt-colors-color-palette-orange-2)",
    "variable": "var(--bmt-colors-color-palette-orange-2)"
  },
  "colors.colorPalette.orange.3": {
    "value": "var(--bmt-colors-color-palette-orange-3)",
    "variable": "var(--bmt-colors-color-palette-orange-3)"
  },
  "colors.colorPalette.orange.overlay": {
    "value": "var(--bmt-colors-color-palette-orange-overlay)",
    "variable": "var(--bmt-colors-color-palette-orange-overlay)"
  },
  "colors.colorPalette.purple.1": {
    "value": "var(--bmt-colors-color-palette-purple-1)",
    "variable": "var(--bmt-colors-color-palette-purple-1)"
  },
  "colors.colorPalette.purple.2": {
    "value": "var(--bmt-colors-color-palette-purple-2)",
    "variable": "var(--bmt-colors-color-palette-purple-2)"
  },
  "colors.colorPalette.purple.3": {
    "value": "var(--bmt-colors-color-palette-purple-3)",
    "variable": "var(--bmt-colors-color-palette-purple-3)"
  },
  "colors.colorPalette.purple.overlay": {
    "value": "var(--bmt-colors-color-palette-purple-overlay)",
    "variable": "var(--bmt-colors-color-palette-purple-overlay)"
  },
  "colors.colorPalette.navy.1": {
    "value": "var(--bmt-colors-color-palette-navy-1)",
    "variable": "var(--bmt-colors-color-palette-navy-1)"
  },
  "colors.colorPalette.navy.2": {
    "value": "var(--bmt-colors-color-palette-navy-2)",
    "variable": "var(--bmt-colors-color-palette-navy-2)"
  },
  "colors.colorPalette.navy.3": {
    "value": "var(--bmt-colors-color-palette-navy-3)",
    "variable": "var(--bmt-colors-color-palette-navy-3)"
  },
  "colors.colorPalette.navy.overlay": {
    "value": "var(--bmt-colors-color-palette-navy-overlay)",
    "variable": "var(--bmt-colors-color-palette-navy-overlay)"
  },
  "colors.colorPalette.weakest": {
    "value": "var(--bmt-colors-color-palette-weakest)",
    "variable": "var(--bmt-colors-color-palette-weakest)"
  },
  "colors.colorPalette.onPrimary.disabled": {
    "value": "var(--bmt-colors-color-palette-on-primary-disabled)",
    "variable": "var(--bmt-colors-color-palette-on-primary-disabled)"
  },
  "colors.colorPalette.inverse": {
    "value": "var(--bmt-colors-color-palette-inverse)",
    "variable": "var(--bmt-colors-color-palette-inverse)"
  },
  "colors.colorPalette.critical.hover": {
    "value": "var(--bmt-colors-color-palette-critical-hover)",
    "variable": "var(--bmt-colors-color-palette-critical-hover)"
  },
  "colors.colorPalette.critical.active": {
    "value": "var(--bmt-colors-color-palette-critical-active)",
    "variable": "var(--bmt-colors-color-palette-critical-active)"
  },
  "colors.colorPalette.link": {
    "value": "var(--bmt-colors-color-palette-link)",
    "variable": "var(--bmt-colors-color-palette-link)"
  },
  "colors.colorPalette.link.hover": {
    "value": "var(--bmt-colors-color-palette-link-hover)",
    "variable": "var(--bmt-colors-color-palette-link-hover)"
  },
  "colors.colorPalette.link.active": {
    "value": "var(--bmt-colors-color-palette-link-active)",
    "variable": "var(--bmt-colors-color-palette-link-active)"
  },
  "colors.colorPalette.accent.teal.strong": {
    "value": "var(--bmt-colors-color-palette-accent-teal-strong)",
    "variable": "var(--bmt-colors-color-palette-accent-teal-strong)"
  },
  "colors.colorPalette.teal.strong": {
    "value": "var(--bmt-colors-color-palette-teal-strong)",
    "variable": "var(--bmt-colors-color-palette-teal-strong)"
  },
  "colors.colorPalette.accent.gold.strong": {
    "value": "var(--bmt-colors-color-palette-accent-gold-strong)",
    "variable": "var(--bmt-colors-color-palette-accent-gold-strong)"
  },
  "colors.colorPalette.gold.strong": {
    "value": "var(--bmt-colors-color-palette-gold-strong)",
    "variable": "var(--bmt-colors-color-palette-gold-strong)"
  },
  "colors.colorPalette.accent.purple": {
    "value": "var(--bmt-colors-color-palette-accent-purple)",
    "variable": "var(--bmt-colors-color-palette-accent-purple)"
  },
  "colors.colorPalette.purple": {
    "value": "var(--bmt-colors-color-palette-purple)",
    "variable": "var(--bmt-colors-color-palette-purple)"
  },
  "colors.colorPalette.accent.blue.strong": {
    "value": "var(--bmt-colors-color-palette-accent-blue-strong)",
    "variable": "var(--bmt-colors-color-palette-accent-blue-strong)"
  },
  "colors.colorPalette.blue.strong": {
    "value": "var(--bmt-colors-color-palette-blue-strong)",
    "variable": "var(--bmt-colors-color-palette-blue-strong)"
  },
  "colors.colorPalette.accent.navy": {
    "value": "var(--bmt-colors-color-palette-accent-navy)",
    "variable": "var(--bmt-colors-color-palette-accent-navy)"
  },
  "colors.colorPalette.navy": {
    "value": "var(--bmt-colors-color-palette-navy)",
    "variable": "var(--bmt-colors-color-palette-navy)"
  },
  "colors.colorPalette.placeholder": {
    "value": "var(--bmt-colors-color-palette-placeholder)",
    "variable": "var(--bmt-colors-color-palette-placeholder)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar